/**
 * @component Kbd
 * @description shadcn/ui 기반 컴포넌트. CSS 변수를 활용한 테마 시스템 적용.
 * @based-on shadcn/ui + Figma design specification
 */

import { forwardRef, HTMLAttributes } from 'react';
import { cva } from 'class-variance-authority';
import { cn } from '../lib/utils';

export type KbdSize = 'small' | 'regular';

export interface KbdProps extends HTMLAttributes<HTMLElement> {
  size?: KbdSize;
}

const kbdVariants = cva(
  'inline-flex items-center justify-center rounded border border-border bg-accent-0 font-mono text-foreground shadow-sm',
  {
    variants: {
      size: {
        small: 'h-5 min-w-5 px-1.5 text-xs',
        regular: 'h-6 min-w-6 px-2 text-sm',
      },
    },
    defaultVariants: {
      size: 'regular',
    },
  }
);

export const Kbd = forwardRef<HTMLElement, KbdProps>(
  ({ className, size, children, ...props }, ref) => {
    return (
      <kbd
        ref={ref}
        className={cn(kbdVariants({ size }), className)}
        {...props}
      >
        {children}
      </kbd>
    );
  }
);

Kbd.displayName = 'Kbd';
